import { createElement } from "react";
import { IconSvg, type IconSvgProps } from "@contra/icons/icons";
export const ContraLogoIcon = (props: IconSvgProps) =>
  createElement(
    IconSvg,
    {
      ...props,
      viewBox: "0 0 22 22",
    },
    <g filter="url(#contra-logo_svg__a)">
      <path
        fill="url(#contra-logo_svg__b)"
        fillRule="evenodd"
        d="M12.194 0a.23.23 0 0 1 .223.177l.33 1.4a10.31 10.31 0 0 0 7.676 7.677l1.4.33a.23.23 0 0 1 .177.223v.39a.23.23 0 0 1-.23.23h-9.968a.23.23 0 0 1-.23-.23V.23a.23.23 0 0 1 .23-.229zm-1.996 10.427a.23.23 0 0 0 .23-.23V.23a.23.23 0 0 0-.23-.229h-.392a.23.23 0 0 0-.223.177l-.33 1.4a10.31 10.31 0 0 1-7.676 7.677l-1.4.33A.23.23 0 0 0 0 9.806v.39c0 .128.103.23.23.23zM.229 11.573a.23.23 0 0 0-.229.23v.39a.23.23 0 0 0 .177.224l1.4.33a10.31 10.31 0 0 1 7.677 7.676l.33 1.4a.23.23 0 0 0 .223.177h.39a.23.23 0 0 0 .23-.23v-9.968a.23.23 0 0 0-.23-.23zm11.344.23a.23.23 0 0 1 .23-.23h9.968a.23.23 0 0 1 .229.23v.39a.23.23 0 0 1-.177.224l-1.4.33a10.31 10.31 0 0 0-7.677 7.676l-.33 1.4a.23.23 0 0 1-.223.177h-.39a.23.23 0 0 1-.23-.23z"
        clipRule="evenodd"
      />
    </g>,
    <defs>
      <linearGradient
        id="contra-logo_svg__b"
        x1={9.167}
        x2={16.042}
        y1={5.5}
        y2={16.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.051} stopColor="#FF9E39" />
        <stop offset={0.085} stopColor="#FB7307" />
        <stop offset={0.21} stopColor="#FB8832" />
        <stop offset={0.318} stopColor="#FFD1D1" />
        <stop offset={0.51} stopColor="#FFC0BC" />
        <stop offset={0.737} stopColor="#FFC560" />
        <stop offset={1} stopColor="#FAB029" />
      </linearGradient>
      <filter
        id="contra-logo_svg__a"
        width={22.917}
        height={22.917}
        x={-0.458}
        y={-0.458}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-0.458} dy={0.458} />
        <feGaussianBlur stdDeviation={0.229} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 0.9 0 0 0 0 0.943902 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_567_23468" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={0.458} dy={-0.458} />
        <feGaussianBlur stdDeviation={0.458} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.847059 0 0 0 0 0.333333 0 0 0 0 0.227451 0 0 0 0.6 0" />
        <feBlend
          in2="effect1_innerShadow_567_23468"
          result="effect2_innerShadow_567_23468"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.458} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.854152 0 0 0 0 0.17878 0 0 0 0 0.0395814 0 0 0 1 0" />
        <feBlend
          in2="effect2_innerShadow_567_23468"
          result="effect3_innerShadow_567_23468"
        />
      </filter>
    </defs>
  );
